import { useState } from 'react';
import { DeleteForbiddenModal } from '../../../../components/DeleteForbiddenModal/DeleteForbiddenModal';
import { Page } from '../../../../components/Page/Page';
import {
  SubjectContainerUsedIn,
  SubjectContainerUsedInDataType,
} from '../../../../components/SubjectContainer/components/SubjectContainerUsedIn';
import { SubjectContainerModal } from '../../../../components/SubjectContainer/modals/SubjectContainerModal';
import { SubjectContainersTable } from '../../../../components/SubjectContainer/Tables/SubjectContainersTable';
import { useMemorizedCacheTag } from '../../../../hooks/useMemorizedCacheTag';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import {
  _SubjectContainersUsedInDocument,
  _SubjectContainersUsedInQuery,
  _SubjectContainersUsedInQueryVariables,
  useDeleteSubjectContainerMutation,
} from '../../../../types/planung-graphql-client-defs';
import { urqlClient } from '../../../../utils/urqlClient';

export const DeputateSubjectContainersSubpage = () => {
  const context = useMemorizedCacheTag('SUBJECT_CONTAINER');
  const permissions = usePermissionChecker();

  const [, deleteSubjectContainer] = useDeleteSubjectContainerMutation();

  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [deleteForbidden, setDeleteForbidden] = useState<SubjectContainerUsedInDataType | null>(null);

  const [subjectContainerUuid, setSubjectContainerUuid] = useState<string | null>(null);

  function handleClose() {
    setSubjectContainerUuid(null);
    setModalOpen(false);
  }

  function handleAdd() {
    setSubjectContainerUuid(null);
    setModalOpen(true);
  }

  function handleEdit(uuid: string) {
    setSubjectContainerUuid(uuid);
    setModalOpen(true);
  }

  async function handleDelete(uuids: string[]) {
    setTableLoading(true);

    const { data } = await urqlClient
      .query<_SubjectContainersUsedInQuery, _SubjectContainersUsedInQueryVariables>(_SubjectContainersUsedInDocument, {
        uuids: uuids,
      })
      .toPromise();

    if (data?.subjectContainers && data?.subjectContainers.length > 0) {
      setTableLoading(false);
      setDeleteForbidden(data.subjectContainers[0]);
      return;
    }
    await deleteSubjectContainer({ uuid: uuids[0] }, context);
    setTableLoading(false);
  }

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <SubjectContainersTable loading={tableLoading} onAdd={handleAdd} onEdit={handleEdit} onDelete={handleDelete} />
      <SubjectContainerModal isOpen={modalOpen} onClose={handleClose} subjectContainerUuid={subjectContainerUuid} />
      <DeleteForbiddenModal open={!!deleteForbidden} onClose={() => setDeleteForbidden(null)}>
        {deleteForbidden && <SubjectContainerUsedIn data={deleteForbidden} />}
      </DeleteForbiddenModal>
    </Page>
  );
};
